module.exports = __webpack_public_path__ + "img/cx.cx3760646.svg";